// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"9e61c017","234":"b6d2780b","349":"60ba07ae","359":"60bca7fa","361":"393fccfc","511":"381e0f9a","812":"5361d552"}[chunkId] + ".chunk.js";
};